import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import Link from '../../../Link';
import { clickSignupButton, clickedNavLinkGoogleAnalytics } from '../../events';

import styles from './styles.sass';
import LinkStyles from '../../LinkStyles.sass';

const cxLinkStyles = classnames.bind(LinkStyles);

const SignUpLoginNavItems = ({ pathname }) => {
  const pathnameLowerCase = pathname.toLowerCase();
  return (
    <div className={styles.wrapper}>
      <Link
        to={pathnameLowerCase === '/wordpress' ? '/signup?ref=wp' : '/signup'}
        className={styles.buttonLink}
        onClick={() => {
          clickSignupButton();
          clickedNavLinkGoogleAnalytics('Sign Up');
        }}
      >
        Sign up
      </Link>
      <Link
        to="/login"
        onClick={() => {
          clickedNavLinkGoogleAnalytics('Log In');
        }}
        className={`${styles.link} ${cxLinkStyles({
          link: true,
          linkActive: pathnameLowerCase === '/login',
        })}`}
      >
        Log in
      </Link>
    </div>
  );
};

SignUpLoginNavItems.defaultProps = {
  pathname: null,
};

SignUpLoginNavItems.propTypes = {
  pathname: PropTypes.string,
};

export { SignUpLoginNavItems };
